import * as React from 'react';
import theme from '../theme/theme';
import { Avatar, Box, Grid, Typography, useMediaQuery } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faArrowRight, faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const ButtonMatch = (props) => {

  const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <Box 
    disableElevation
    sx={{display: 'block', backgroundColor: props.boost ? 
        theme.palette.primary.main : theme.palette.primary.contrastText, 
        padding: '10px 12px 10px 12px', borderRadius: '30px',
    '&:hover': { boxShadow: 'rgba(0, 0, 0, 0.15) 0px 3px 34px 0px', backgroundColor: theme.palette.grey[50], cursor: 'pointer' } }}
    onClick={props.click}
    >
        <Grid container direction="row" alignItems="center">
            {props.type === "left" ?
            <Grid item sx={{width: isSmUp ? '44px' : '28px'}}>
                <FontAwesomeIcon icon={faArrowLeft} style={{fontSize: isSmUp ? '26px' : '16px', color: theme.palette.grey[700], margin: '0px 10px 0px 3px'}} />
            </Grid>
            :''}
            <Grid item sx={{width: isSmUp ? '36px' : '24px'}}>
                <Avatar src={props.match.homeTeam.flag} sx={{ width: isSmUp ? '25px' : '15px', height: isSmUp ? '25px' : '15px', margin: '3px 0px 3px 0px'}} />
            </Grid>
            <Grid item sx={{width: isSmUp ? '36px' : '24px'}}>
                <Typography className={"boldest"} sx={{ fontSize: isSmUp ? '16px' : '13px'}}>
                {props.match.homeTeam.country}
                </Typography>
            </Grid>
            <Grid item sx={{width: isSmUp ? '10px' : '5px'}}  container justifyContent="center">
                -
            </Grid>
            <Grid item sx={{width: isSmUp ? '36px' : '24px'}} container justifyContent="flex-end">
                <Typography className={"boldest"} sx={{ fontSize: isSmUp ? '16px' : '13px'}}>
                {props.match.awayTeam.country}
                </Typography>
            </Grid>
            <Grid item sx={{width: isSmUp ? '36px' : '24px'}} container justifyContent="flex-end">
                <Avatar src={props.match.awayTeam.flag} sx={{ width: isSmUp ? '25px' : '15px', height: isSmUp ? '25px' : '15px', margin: '3px 0px 3px 0px'}} />
            </Grid>
            {props.type === "right" ?
            <Grid item sx={{width: isSmUp ? '44px' : '28px'}} container justifyContent="flex-end">
                <FontAwesomeIcon icon={faArrowRight} style={{fontSize: isSmUp ? '26px' : '16px', color: theme.palette.grey[700], margin: '0px 3px 0px 10px'}} />
            </Grid>
            :''}
        </Grid>
    </Box>
  );
};
export default ButtonMatch;